import { createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "../../../services/axois";
import { API_ROUTES } from "../../../utility/api.routes";
import { toast } from "react-toastify";


export const getState = createAsyncThunk(
    "masterDataSet/getState",
     async () => {
      try {
      const url = API_ROUTES.MASTER_DATA_SET.GET_STATE_LIST
        const response = await apiClient.get(url);
        return response.data
      } catch (error) {
        console.error("builder function error:", error);
        throw error;
      }
    }
  );

  export const getCity = createAsyncThunk(
    "masterDataSet/getCity",
    async () => {
      try {
        const url = API_ROUTES.MASTER_DATA_SET.GET_CITY_LIST
        const response = await apiClient.get(url);
        return response.data
      } catch (error) {
        console.error("builder function error:", error);
        throw error;
      }
    }
  );
  
export const getArea = createAsyncThunk(
    "masterDataSet/getArea",
     async () => {
      try {
        const url = API_ROUTES.MASTER_DATA_SET.GET_AREA_LIST
        const response = await apiClient.get(url);
        return response.data
      } catch (error) {
        console.error("builder function error:", error);
        throw error;
      }
    }
  );
  
 export const getCityByStateId = createAsyncThunk(
  "masterDataSet/getCityByStateId",
  async (stateId) => {
    try {
      const url = API_ROUTES.MASTER_DATA_SET.GET_CITY_BY_STATE_ID(stateId)
      const response = await apiClient.get(url);
      return response.data.result
    } catch (error) {
      console.error("builder function error:", error);
      throw error;
    }
  }
);
  

export const getAreaByCityId = createAsyncThunk(
  "masterDataSet/getAreaByCityId",
  async (cityId) => {
    try {
      const url = API_ROUTES.MASTER_DATA_SET.GET_AREA_BY_CITY_ID(cityId)
      const response = await apiClient.get(url);
      return response.data.result
    } catch (error) {
      console.error("builder function error:", error);
      throw error;
    }
  }
);


  export const getTempCity = createAsyncThunk(
    "masterDataSet/getTempCity",
    async () => {
      try {
        const url = API_ROUTES.MASTER_DATA_SET.GET_CITY_LIST
        const response = await apiClient.get(url);
        return response.data
      } catch (error) {
        console.error("builder function error:", error);
        throw error;
      }
    }
  );
  
export const getTempArea = createAsyncThunk(
    "masterDataSet/getTempArea",
     async () => {
      try {
        const url = API_ROUTES.MASTER_DATA_SET.GET_AREA_LIST
        const response = await apiClient.get(url);
        return response.data
      } catch (error) {
        console.error("builder function error:", error);
        throw error;
      }
    }
  );
  
 export const getTempCityByStateId = createAsyncThunk(
  "masterDataSet/getTempCityByStateId",
  async (stateId) => {
    try {
      const url = API_ROUTES.MASTER_DATA_SET.GET_CITY_BY_STATE_ID(stateId)
      const response = await apiClient.get(url);
      return response.data.result
    } catch (error) {
      console.error("builder function error:", error);
      throw error;
    }
  }
);
  

export const getTempAreaByCityId = createAsyncThunk(
  "masterDataSet/getTempAreaByCityId",
  async (cityId) => {
    try {
      const url = API_ROUTES.MASTER_DATA_SET.GET_AREA_BY_CITY_ID(cityId)
      const response = await apiClient.get(url);
      return response.data.result
    } catch (error) {
      console.error("builder function error:", error);
      throw error;
    }
  }
);



export const addArea = createAsyncThunk(
  "masterDataSet/addArea",
  async (data,{ dispatch }) => {

    const areaData = {
      areaName: data.value.areaName,
      cityId: data.value.city
    }
    try {
      let url = `/area`;
      const response = await apiClient.post(url, areaData);

      dispatch(getArea())

      if (response.status) {
        data.setOpen(false)
        toast.success(response.data.message, {
          className: 'custom-toast-success',
          progressStyle: { background: '#ffffff' },
       })
      }
    } catch (error) {
      console.error("builder function error:", error);

      toast.error(error.response.data.message, {
        className: 'custom-toast-error',
        // progressStyle: { background: '#C53C43' },
      })

      throw error;
    }
  }
);

export const editArea = createAsyncThunk(
  "masterDataSet/editArea",
  async (data,{ dispatch }) => {

    const areaData = {
      areaName: data.value.areaName,
      cityId: data.value.city
    }
    try {
      let url = `/area/${data.value.areaId}`;
      const response = await apiClient.put(url, areaData);

      dispatch(getArea())

      if (response.status) {
        data.setEditInventoryDrawer(false)
        toast.success(response.data.message, {
          className: 'custom-toast-success',
          progressStyle: { background: '#ffffff' },
       })
      }
    } catch (error) {
      console.error("builder function error:", error);

      toast.error(error.response.data.message, {
        className: 'custom-toast-error',
        // progressStyle: { background: '#C53C43' },
      })

      throw error;
    }
  }
);


export const getEducationQualification = createAsyncThunk(
  "masterDataSet/getEducationQualification",
  async () => {
    try {
      let url = `/education-qualification?type=all`
      const response = await apiClient.get(url);
      return response.data.result
    } catch (error) {
      console.error("builder function error:", error);
      throw error;
    }
  }
);


export const addEducationQualification = createAsyncThunk(
  "masterDataSet/addEducationQualification",
  async (data,{ dispatch }) => {

    const educationQualificationData = {
      educationQualificationName : data.value.educationQualificationName,
      educationQualificationStatus : "active"
    }

    try {
      let url = `/education-qualification`
      const response = await apiClient.post(url, educationQualificationData);

      dispatch(getEducationQualification())

      if (response.status) {
        data.setOpen(false)
        toast.success(response.data.message, {
          className: 'custom-toast-success',
          progressStyle: { background: '#ffffff' },
       })
      }
    } catch (error) {
      console.error("builder function error:", error);

      toast.error(error.response.data.message, {
        className: 'custom-toast-error',
        // progressStyle: { background: '#C53C43' },
      })

      throw error;
    }
  }
);


export const editEducationQualification = createAsyncThunk(
  "masterDataSet/editEducationQualification",
  async (data,{ dispatch }) => {

    const educationQualificationData = {
      educationQualificationName: data.value.educationQualificationName,
      educationQualificationStatus: data.value.educationQualificationStatus,
    }
    try {
      let url = `/education-qualification/${data.value.educationQualificationId}`;
      const response = await apiClient.put(url, educationQualificationData);

      dispatch(getEducationQualification())

      if (response.status) {
        data.setEditInventoryDrawer(false)
        toast.success(response.data.message, {
          className: 'custom-toast-success',
          progressStyle: { background: '#ffffff' },
       })
      }
    } catch (error) {
      console.error("builder function error:", error);

      toast.error(error.response.data.message, {
        className: 'custom-toast-error',
        // progressStyle: { background: '#C53C43' },
      })

      throw error;
    }
  }
);